module.exports = __webpack_public_path__ + "static/media/bg-login@2x.601c2aba.jpg";